/*
 * NextGenn engine · "Goes with", inside the bag (snippets/ngs-goes-with.liquid).
 *
 * The deck is drawn once, with every card hidden and each one carrying the two
 * bottles it pairs with. This picks the cards to show: the pairs of whatever is
 * in the bag, minus anything already in it, capped at two.
 *
 * NO REQUEST IS MADE TO DECIDE. The bag's own contents arrive with the event
 * that redrew the drawer, and the pairings are already in the HTML, so opening
 * the bag never waits on the network to know what to offer.
 *
 * It is DELIBERATELY QUIET WHEN IT HAS NOTHING GOOD TO SAY: an empty bag, or a
 * bag holding everything a bottle pairs with, shows nothing at all rather than
 * falling back to "popular products", which is the tell of a shop that does not
 * know its own catalogue.
 */
if (!customElements.get('ngs-goes-with')) {
  customElements.define(
    'ngs-goes-with',
    class NGSGoesWith extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = Array.prototype.slice.call(this.querySelectorAll('.ngs-goes__card'));
        this.most = Number(this.dataset.most) || 2;
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.ask();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      ask() {
        var self = this;
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            self.decide(cart);
          })
          .catch(function () {
            self.hidden = true;
          });
      }

      decide(cart) {
        var held = {};
        var wanted = [];
        (cart.items || []).forEach(function (line) {
          if (line.handle) held[line.handle] = true;
        });

        /* The pairs of what is in the bag, in the order the bag was filled, so
           the first bottle somebody chose is the one we answer first. */
        this.cards.forEach(function (card) {
          if (held[card.dataset.handle]) {
            (card.dataset.pairs || '').split(/\s+/).forEach(function (mate) {
              if (mate && !held[mate] && wanted.indexOf(mate) === -1) wanted.push(mate);
            });
          }
        });

        var shown = 0;
        var most = this.most;
        this.cards.forEach(function (card) {
          var on = shown < most && wanted.indexOf(card.dataset.handle) !== -1;
          card.hidden = !on;
          if (on) shown += 1;
        });
        this.hidden = shown === 0;
      }

      onClick(event) {
        var button = event.target.closest('.ngs-goes__add');
        if (!button || button.disabled) return;
        var id = button.dataset.variant;
        if (!id || !window.NGSCart) return;
        var said = button.textContent;
        button.disabled = true;
        button.textContent = button.dataset.adding || said;
        /* The drawer redraws itself when this lands, which takes the deck with
           it: the copy mounted into the new drawer asks the bag again. */
        window.NGSCart.add([{ id: id, quantity: 1 }]).catch(function () {
          button.disabled = false;
          button.textContent = said;
        });
      }
    }
  );
}
